<template>
  <Component
    :is="link ? Link : 'button'"
    class="relative outline-offset-[3px]"
    :disabled="disabled"
    :class="[disabled && 'cursor-not-allowed', btnClasses]"
  >
    <slot></slot>
  </Component>
</template>

<script setup>
import { useDesignSystem } from '@/composables/designSystem'
import { Link } from '@inertiajs/vue3'
import { computed } from 'vue'

const props = defineProps({
  link: {
    type: Boolean,
    default: () => false,
  },
  variant: {
    type: String,
    default: 'primary',
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
})

// The design-system look uses the design system's button (.app-btn in
// resources/css/design-system/theme.css) instead of the Tailwind classes below.
const designSystem = useDesignSystem()

const btnClasses = computed(() => {
  if (designSystem.value) {
    if (props.variant === 'danger') {
      return 'app-btn app-btn--secondary border-(--ds-action-danger) text-(--ds-action-danger) enabled:hover:bg-(--ds-status-error-bg)'
    }

    return props.variant === 'outline'
      ? 'app-btn app-btn--secondary'
      : 'app-btn app-btn--brand'
  }

  const base =
    'flex items-center justify-center gap-2 whitespace-nowrap rounded-[5px] py-2 px-6 md:px-[26px] text-tiny md:text-sm'

  if (props.variant === 'danger') {
    return `${base} bg-transparent border border-error-strong font-medium text-error-strong transition-all duration-500 ease-in-out enabled:hover:bg-error-strong enabled:hover:text-white disabled:cursor-not-allowed disabled:opacity-50`
  }

  if (props.variant === 'outline') {
    return `${base} hover:bg-primary hover:text-white bg-transparent border border-primary font-medium text-primary transition-all duration-500 ease-in-out disabled:cursor-not-allowed disabled:opacity-50`
  }

  return `${base} bg-primary font-medium text-white transition-all duration-500 ease-in-out hover:bg-primary-dark disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-primary`
})
</script>
